"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xrp(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.3025 5.78888H19.47L14.9587 10.2566C14.17 11.0337 13.1072 11.4693 12 11.4693C10.8928 11.4693 9.82998 11.0337 9.04125 10.2566L4.52625 5.78888H6.6975L10.125 9.18113C10.6241 9.67377 11.2972 9.95 11.9985 9.95C12.6998 9.95 13.3729 9.67377 13.872 9.18113L17.3025 5.78888ZM6.67125 18.2111H4.5L9.04125 13.7164C9.82998 12.9393 10.8928 12.5037 12 12.5037C13.1072 12.5037 14.17 12.9393 14.9587 13.7164L19.5 18.2104H17.3287L13.875 14.7889C13.3759 14.2962 12.7028 14.02 12.0015 14.02C11.3002 14.02 10.6271 14.2962 10.128 14.7889L6.6705 18.2111H6.67125Z", fill: color }));
}
exports["default"] = xrp;
//# sourceMappingURL=xrp.js.map